import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as settings from "../../../constants/settings";
import * as navigationActions from "../../../actions/navigationActions";
import * as computerActions from "../../../actions/computerActions";
import * as windowService from "../../../services/windowService";
import * as modelHelper from "../../../helpers/modelHelper";

import imgConfirm from "../../../resources/img/svgicons/confirm.svg";
import Modal from "../generic/Modal";
import Button from "../generic/Button";
import CancelButton from "../generic/CancelButton";

class RestartModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleRestartClick = () => {
        switch (this.props.params.type) {
            case settings.LOCK_COMPUTER:
                this.props.dispatchRestartComputerAction();
                break;
            default:
                windowService.restartRedlike();
                break;
        }
    };

    getRestartModalTitle = () => {
        switch (this.props.params.type) {
            case settings.LOCK_COMPUTER:
                return <Translate value="restartModal.computerNeedsRestart" />;
            default:
                return <Translate value="restartModal.softwareNeedsRestart" name={this.props.softwareName} />;
        }
    };

    getRestartModalMessage = () => {
        if (this.props.params.message === null) {
            return "";
        }

        return this.props.params.message;
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    svgBefore={imgConfirm}
                    label={<Translate value="general.confirm" />}
                    onClick={this.handleRestartClick}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.tabId}
                header={modelHelper.buildModalSection(this.getRestartModalTitle())}
                content={modelHelper.buildModalSection(this.getRestartModalMessage())}
                footer={this.getFooter()}
                onClose={this.handleCloseModalClick}
                styles={{minHeight: "30%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        softwareName: store.settings.softwareName
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.RESTART_MODAL));
        },
        dispatchRestartComputerAction: () => {
            dispatch(computerActions.restartComputer());
        }
    };
};

export default RestartModal = connect(mapStoreToProps, mapDispatchToProps)(RestartModal);
